/**
 * Footer 브랜드 정보
 */
export const FOOTER_BRAND = {
  tagline: '배우와 제작사를 연결하는\nAI 캐스팅 플랫폼',
  copyright: '© 2025 Castar. All rights reserved.',
};

/**
 * Footer 네비게이션 컬럼 데이터
 */
export const FOOTER_NAV = [
  {
    id: 'support',
    title: '고객지원',
    links: [
      { id: 'community', label: '커뮤니티', path: '/community' },
      { id: 'faq', label: '자주 묻는 질문', path: '/faq' },
    ],
  },
  {
    id: 'policy',
    title: '약관 및 정책',
    links: [
      { id: 'terms', label: '서비스 이용약관', modal: 'terms' },
      { id: 'privacy', label: '개인정보처리방침', modal: 'privacy' },
      { id: 'marketing', label: '개인정보 수집·이용 및 제3자 제공', modal: 'marketing' },
      { id: 'aiTraining', label: 'AI 학습·모델 고도화 동의', modal: 'aiTraining' },
    ],
  },
];